<template>
  <div class="dataTableContainer">
    <div class="outline">
      <section class="content">
        <div class="scrollTop">
          <ul ref="scrollTop">
            <li v-for="(item, index) in tableHeadX" :key="index" @click="selectCol(index)">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div class="scrollLeft">
          <ul ref="scrollLeft">
            <li v-for="(item, index) in tableHeadY" :key="index" @click="selectRow(index)">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div class="scrollTable" @scroll="scrollTableHandle" ref="scrollTable">
          <table>
            <tbody>
              <tr v-for="(trItem, trIndex) in tableData.data" :key="'tr-' + trIndex">
                <td
                  :class="
                    trIndex === select.row && tdIndex === select.col
                      ? 'select cell'
                      : trIndex === editing.row && tdIndex === editing.col
                      ? 'editing cell'
                      : 'cell'
                  "
                  :data-id="trIndex.toString() + '-' + tdIndex.toString()"
                  v-for="(tdItem, tdIndex) in trItem.td"
                  :key="'td-' + tdIndex"
                  @dblclick="editingTd(trIndex, tdIndex, tdItem)"
                  @click="selectTd(trIndex, tdIndex)"
                >
                  <input
                    v-if="editing.row === trIndex && editing.col === tdIndex"
                    v-focus
                    class="data-editor"
                    @change="getCurrentInputValHandle(tableData.data[trIndex].td[tdIndex], trIndex, tdIndex)"
                    v-model="tableData.data[trIndex].td[tdIndex]"
                  />
                  <span v-else class="value-viewer">{{ tdItem }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="selectArea">
          <div :class="selectRow_Col" :style="{ top: `${selectRow_top}px`, left: `${selectCol_left}px` }">
            <el-tooltip :content="delete_content" :placement="delete_placement">
              <span class="deleteIcon" @click="deleteArea">
                <i class="icon-portal-minus"></i>
              </span>
            </el-tooltip>
          </div>
        </div>
      </section>
      <div class="topLeft"></div>
    </div>
  </div>
</template>
<script>
import { _throttle } from "../../../../../utils"

export default {
  name: "bar-series-data",
  props: {
    options: {
      type: Object
    },
    seriesDataDimensionOne: {
      // 作为x维度数据
      type: Object
    },
    seriesDataDimensionTwo: {
      // 作为y维度数据
      type: Array
    },
    index: {
      // 当前数据在series中的下标位置
      type: Number
    },
    type: {
      // 当前series的图表类型
      type: String
    },
    defaultColor: { type: Array },
    defaultGradientColor: { type: Array }
  },
  data() {
    return {
      this1: this,
      tableHeadX: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      tableHeadY: [],
      tableData: {
        data: []
      },
      select: { row: null, col: null },
      editing: { row: null, col: null },
      tableX: [],
      tableY: [],
      tableMax: [],
      interval: 3,
      selectRow_Col: "",
      select_index: 0,
      selectRow_top: 0,
      selectCol_left: 0,
      delete_content: "",
      delete_placement: ""
    }
  },
  comments: {},
  created() {
    this.init()
  },
  watch: {
    seriesDataDimensionOne: {
      deep: true,
      handler(n, o) {
        this.init()
        // 水位图的最大值修改同步到图表上
        if(this.options.type == "LiquidFill" && this.options.chartOption.maxAutoSet){
          if(n.data[0].max !== this.options.chartOption.maxAutoValue){
            this.getCurrentInputValHandle(this.options.chartOption.maxAutoValue, 1, 2)
          }
        }
      }
    }
  },
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {
    // 初始化数据表格
    init() {
      let defaultDataLen = 21
      // 刻度表仅支持一条数据
      if (this.options.type === "Gauge") {
        defaultDataLen = 3
      }
      // 每次更新的时候清空表格
      this.tableData.data = []
      this.tableHeadY = []
      for (let i = 1; i < defaultDataLen; i++) {
        this.tableHeadY.push(String(i))
        if (i > 1) {
          const td = {
            td: ["", "", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(td)
        } else if (
          this.options.type == "Radar" ||
          this.options.type === "Gauge" ||
          this.options.type === "LiquidFill"
        ) {
          const th = {
            td: ["value", "name", "max", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(th)
        } else if (
          this.options.type == "Pie" ||
          this.options.type == "pie3D" ||
          (this.options.type == "Bar" && this.options.chartOption.radiusAxis?.type == "category")
        ) {
          const th = {
            td: ["value", "name", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(th)
        } else if (this.options.type == "Bar" && this.options.chartOption.xAxis?.type === "value") {
          const th = {
            td: ["x", "y", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(th)
        } else {
          const th = {
            td: ["y", "x", "", "", "", "", "", "", "", ""]
          }
          this.tableData.data.push(th)
        }
      }
      // 如果是雷达图将最大值注入到tableData的data中
      if (this.options.type == "Radar") {
        this.tableMax = [
          ...this.options.chartOption.radar.indicator.map(item => {
            return item.max
          })
        ]
        this.tableX = [...this.seriesDataDimensionOne.value]
      } else if (this.options.type == "Gauge") {
        // 刻度图需要最大值
        this.tableMax = [this.options.chartOption.series[0].max]
        this.tableX = [
          ...this.seriesDataDimensionOne.data.map(item => {
            return item.value
          })
        ]
      } else if (this.options.type == "LiquidFill") {
        //水球图需要最大值
        let maxValue = 100, maxAutoSet = false
        if(this.options.chartOption.maxAutoSet){
          maxAutoSet = true
          maxValue = this.options.chartOption.maxAutoValue
        }
        this.tableMax = [
          ...this.seriesDataDimensionOne.data.map(item => {
            return maxAutoSet ? maxValue : (item.max || maxValue)
          })
        ]
        this.tableX = [
          ...this.seriesDataDimensionOne.data.map(item => {
            let defaultMax = item.max || maxValue
            // return (item.value * defaultMax).toFixed(0)
            let value0 = item.value * defaultMax
            if(item.realValue){
              value0 = item.realValue
            }
            return value0
          })
        ]
      } else if (this.options.type === "pie3D") {
        // 取最后一个series的data
        let data = this.options.chartOption.series[this.options.chartOption.series.length - 1].data
        this.tableX = [
          ...data.map(item => {
            return item.value
          })
        ]
      } else {
        this.tableX = [
          ...this.seriesDataDimensionOne.data.map(item => {
            return item.value
          })
        ]
      }
      if (this.seriesDataDimensionTwo !== null) {
        this.tableY = [...this.seriesDataDimensionTwo]
        // console.log("tY", this.tableY)
        // this.tableY = [
        //   ...this.seriesDataDimensionTwo.map(item => {
        //     return typeof item.value !== "undefined" ? item.value : item
        //   })
        // ]
        // 如果所有维度数据都为空，去掉该数据
        for (let i = 0; i < this.tableX.length; i++) {
          if (this.tableX[i] === "" && this.tableY[i] === "" && this.tableMax[i] === "") {
            this.tableX.splice(i, 1)
            this.tableY.splice(i, 1)
            this.tableMax.splice(i, 1)
            i = i > 1 ? i - 1 : 0
          }
        }
        // console.log(this.tableX, this.tableY, this.tableMax)
        // 处理数据，将数据填入数据表格
        this.tableData.data.forEach((value, index) => {
          if (index === 0) {
            return
          }
          let tableXValue = index < this.tableX.length + 1 ? this.tableX[index - 1] : ""
          let tableYValue = index < this.tableY.length + 1 ? this.tableY[index - 1] : ""
          let tableMaxValue = index < this.tableMax.length + 1 ? this.tableMax[index - 1] : ""
          this.tableData.data[index].td[0] =
            typeof tableXValue === "object"
              ? tableXValue.realValue
                ? tableXValue.realValue
                : tableXValue.value
              : tableXValue
          this.tableData.data[index].td[1] =
            typeof tableYValue === "object"
              ? tableYValue.realValue
                ? tableYValue.realValue
                : tableYValue.value
              : tableYValue
          this.tableData.data[index].td[2] =
            typeof tableMaxValue === "object"
              ? tableMaxValue.realValue
                ? tableMaxValue.realValue
                : tableMaxValue.max
              : tableMaxValue
        })
      } else {
        for (let i = 0; i < this.tableX.length; i++) {
          if (this.tableX[i] === "") {
            this.tableX.splice(i, 1)
            i = i > 1 ? i - 1 : 0
          }
        }
      }
    },
    // 编辑单元格的时候取消选中
    editingTd(trIndex, tdIndex, tdItem) {
      this.select.row = null
      this.select.col = null
      this.editing.row = trIndex
      this.editing.col = tdIndex
      this.editing.value = tdItem
    },
    // 选中单元格的时候取消编辑
    selectTd(trIndex, tdIndex) {
      if (this.editing.row === trIndex && this.editing.col === tdIndex) return
      this.editing.row = null
      this.editing.col = null
      this.editing.value = null
      this.select.row = trIndex
      this.select.col = tdIndex
    },
    // 格式化修改过后的表格数据，规则校验
    formatTableData(data) {
      this.tableX = []
      this.tableY = []
      for (let i = 1; i < data.length; i++) {
        const tr = data[i].td
        for (let j = 0; j < tr.length; j++) {
          const td = tr[j]
          if (j === 0) {
            this.tableX.push(td)
          }
          if (j === 1) {
            this.tableY.push(td)
          }
        }
      }
    },
    getCurrentInputValHandle(value, trIndex, tdIndex) {
      let temp = JSON.parse(JSON.stringify(this.options.chartOption))
      console.log("value, trIndex, tdIndex", value, trIndex, tdIndex)
      if (tdIndex === 0) {
        if (value === "" || typeof value === "undefined") {
          this.tableX.splice(trIndex - 1, 1) //删除数据
        } else {
          if (this.tableX.length > trIndex - 1) {
            this.tableX[trIndex - 1] = Number(value) //修改数据
          } else {
            if (trIndex - this.tableX.length > 0) {
              //新增数据
              this.tableX[this.tableX.length] = Number(value)
            }
          }
        }
        // 如果是雷达图
        if (temp.series[0].type == "radar") {
          if (this.tableX.length > temp.series[0].data[this.index].value.length) {
            //新增数据
            const tempLength = this.tableX.length - temp.series[0].data[this.index].value.length
            for (let i = 0; i < tempLength; i++) {
              let newData = this.setDefaultColor(
                JSON.parse(JSON.stringify(temp.series[0].data[this.index].value[0])),
                temp.series[0].data[this.index].value.length + i
              )
              temp.series[0].data[this.index].value.push(newData)
            }
          } else if (this.tableX.length < temp.series[0].data[this.index].value.length) {
            //删除数据
            // temp.series[0].data[this.index].value.splice(
            //   this.tableX.length,
            //   temp.series[0].data[this.index].value.length - this.tableX.length
            // )
            const delPos = temp.series[0].data[this.index].value.length - this.tableX.length
            for (let i = 0; i < temp.series[0].data.length; i++) {
              temp.series[0].data[i].value.splice(trIndex - 1, delPos)
            }
          }
          for (let i = 0; i < temp.series[0].data[this.index].value.length; i++) {
            if (this.tableX[i] === "" || typeof this.tableX[i] == "undefined") {
              this.tableX.splice(i, 1)
              temp.series[0].data[this.index].value.splice(temp.series[0].data[this.index].value.length, 1)
              i = i > 1 ? i - 1 : 0
            } else {
              temp.series[0].data[this.index].value[i] = this.tableX[i]
              // }
            }
          }
        } else if (temp.series[0].type === "surface") {
          //3d饼图
          if (this.tableX.length > temp.series.length - 1) {
            // -1 是因为最后一个series是用来设置 label的
            const tempLength = this.tableX.length - temp.series.length + 1
            for (let i = 0; i < tempLength; i++) {
              if (
                Array.isArray(temp.series[temp.series.length - 1].color) &&
                temp.series[temp.series.length - 1].color.length > 0
              ) {
                temp.series[temp.series.length - 1].color.splice(
                  temp.series.length - 1,
                  0,
                  this.defaultColor[(temp.series.length - 1) % this.defaultColor.length]
                )
              }
              let newData = this.setDefaultColor(JSON.parse(JSON.stringify(temp.series[0])), temp.series.length - 1 + i)
              temp.series.splice(temp.series.length - 1, 0, newData)
              temp.series[temp.series.length - 1].data.push({
                name: "",
                value: 0
              })
            }
          } else if (this.tableX.length < temp.series.length - 1) {
            const delPos = temp.series.length - 1 - this.tableX.length
            //删除数据
            if (
              Array.isArray(temp.series[temp.series.length - 1].color) &&
              temp.series[temp.series.length - 1].color.length > 0
            ) {
              temp.series[temp.series.length - 1].color.splice(trIndex - 1, delPos)
            }
            temp.series[temp.series.length - 1].data.splice(trIndex - 1, delPos)
            temp.series.splice(trIndex - 1, delPos)
          }
          let total = 0,
            startRatio = 0,
            endRatio = 0
          for (let i = 0; i < temp.series.length - 1; i++) {
            if (this.tableX[i] === "" || typeof this.tableX[i] == "undefined") {
              this.tableX.splice(i, 1)
              temp.series.splice(i, 1)
              temp.series[temp.series.length - 1].data.splice(i, 1)
              i = i > 1 ? i - 1 : 0
            } else {
              total += parseInt(this.tableX[i])
              temp.series[temp.series.length - 1].data[i].value = this.tableX[i]
            }
          }
          for (let i = 0; i < temp.series.length - 1; i++) {
            let value = parseFloat(temp.series[temp.series.length - 1].data[i].value)
            endRatio = startRatio + value / total
            temp.series[i].pieData.startRatio = startRatio
            temp.series[i].pieData.endRatio = endRatio
            temp.series[i].pieData.value = (endRatio - startRatio) * 10
            startRatio = endRatio
          }
        } else {
          let oldDataLen = temp.series[this.index].data.length
          if (temp.series[0].type === "pie" && temp.series.length > 1 && temp.series[1].type === "gauge") {
            oldDataLen = oldDataLen / 2
          }
          let dataType = 1
          if (this.tableX.length > oldDataLen) {
            //新增数据
            const tempLength = this.tableX.length - oldDataLen
            for (let i = 0; i < tempLength; i++) {
              let newData = {}
              if (temp.series[this.index].data?.length > 0) {
                newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.series[this.index].data[0])),
                  oldDataLen + i
                )
                if (temp.series[this.index].type === "pie") {
                  newData.name = ""
                }
              }
              temp.series[this.index].data.splice(i, 0, newData)
              if (temp.series[0].type === "pie" && temp.series.length > 1 && temp.series[1].type === "gauge") {
                temp.series[this.index].data.push({
                  name: null,
                  value: 0,
                  // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
                  itemStyle: {
                    color: "rgba(0,0,0,0)"
                  },
                  tooltip: {
                    show: false,
                    formatter: null
                  }
                })
              }
            }
          } else if (this.tableX.length < oldDataLen) {
            //删除数据
            const delPos = oldDataLen - this.tableX.length
            for (let i = 0; i < temp.series.length; i++) {
              temp.series[i].data.splice(trIndex - 1, delPos)
            }
            dataType = 2
          } else {
            //  修改数据=====>  this.tableX.length === oldDataLen
            dataType = 3
          }
          if (
            (temp.series[this.index].type === "pie" ||
              temp.series[this.index].type === "line" ||
              temp.series[this.index].type === "bar") &&
            dataType === 1
          ) {
            oldDataLen = oldDataLen + 1
          }
          for (let i = 0; i < oldDataLen; i++) {
            if (this.tableX[i] === "" || typeof this.tableX[i] == "undefined") {
              this.tableX.splice(i, 1)
              temp.series[this.index].data.splice(oldDataLen, 1)
            } else {
              temp.series[this.index].data[i].value = this.tableX[i]
              /* 有横竖轴的本地数据修改时的空数据兼容处理 */
              if (dataType !== 2 && temp.xAxis && temp.yAxis && i === 0) {
                if (temp.xAxis.type === "category" && temp.xAxis.data.length < 1) {
                  temp.xAxis.data.push({ value: "" })
                } else if (temp.yAxis.type === "category" && temp.yAxis.data.length < 1) {
                  temp.yAxis.data.push({ value: "" })
                }
              }
              //   判断是否是柱状图样式12
              if (temp.series[this.index].type === "bar" && temp.styleId === 12) {
                if (temp.series[1].data[i]) {
                  temp.series[1].data[i].value = this.tableX[i]
                  temp.series[2].data[i].value = this.tableX[i]
                } else {
                  let dataI1 = JSON.parse(JSON.stringify(temp.series[1].data[i - 1]))
                  let dataI2 = JSON.parse(JSON.stringify(temp.series[2].data[i - 1]))
                  let dataI3 = JSON.parse(JSON.stringify(temp.series[3].data[i - 1]))
                  temp.series[1].data.push(dataI1)
                  temp.series[2].data.push(dataI2)
                  temp.series[3].data.push(dataI3)
                  temp.series[1].data[i].value = this.tableX[i]
                  temp.series[2].data[i].value = this.tableX[i]
                }
              }
            }
          }
        }
      }
      if (tdIndex === 1) {
        if (value === "" || (typeof value === "undefined" && value === 0)) {
          this.tableY.splice(trIndex - 1, 1) //删除数据
        } else {
          if (this.tableY.length > trIndex - 1) {
            if (typeof this.tableY[trIndex - 1] === "object") {
              if (this.tableY[trIndex - 1].realValue) {
                this.tableY[trIndex - 1].realValue = value
                const yAxis = this.options.chartOption.yAxis
                if (
                  !yAxis.hasOwnProperty("dataValueLengthControl") ||
                  !yAxis.dataValueLengthControl ||
                  this.options.chartOption.pluginName ||
                  !this.options.chartOption.pluginName.find(it => it === "axisLenControlPlugin")
                ) {
                  this.tableY[trIndex - 1].value = value
                }
              } else {
                this.tableY[trIndex - 1].value = value
              }
            } else {
              this.tableY[trIndex - 1] = value //修改数据
            }
          } else {
            if (trIndex - this.tableY.length > 0) {
              //新增数据
              if (typeof this.tableY[this.tableY.length - 1] === "object") {
                if (this.tableY[this.tableY.length - 1].realValue) {
                  this.tableY[this.tableY.length] = JSON.parse(JSON.stringify(this.tableY[this.tableY.length - 1]))
                  this.tableY[this.tableY.length - 1].realValue = value
                  const yAxis = this.options.chartOption.yAxis
                  if (
                    !yAxis.hasOwnProperty("dataValueLengthControl") ||
                    !yAxis.dataValueLengthControl ||
                    !this.options.chartOption.pluginName.find(it => it === "axisLenControlPlugin")
                  ) {
                    this.tableY[this.tableY.length - 1].value = value
                  }
                } else {
                  this.tableY[this.tableY.length] = JSON.parse(JSON.stringify(this.tableY[this.tableY.length - 1]))
                  this.tableY[this.tableY.length - 1].value = value
                }
              } else {
                this.tableY[this.tableY.length] = value
              }
            }
          }
        }
        if (temp.xAxis) {
          if (temp.xAxis.type === "category") {
            if (this.tableY.length > temp.xAxis.data.length) {
              const tempLength = this.tableY.length - temp.xAxis.data.length
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.xAxis.data[0] ? temp.xAxis.data[0] : { value: value })),
                  temp.xAxis.data.length + i
                )
                temp.xAxis.data.push(newData)
              }
            } else if (this.tableY.length < temp.xAxis.data.length) {
              temp.xAxis.data.splice(this.tableY.length, temp.xAxis.data.length - this.tableY.length)
            }
            for (let i = 0; i < temp.xAxis.data.length; i++) {
              // 排除空数据
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.xAxis.data.splice(temp.xAxis.data.length, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                if (typeof temp.xAxis.data[i] === "object") {
                  if (temp.xAxis.data[i].realValue) {
                    temp.xAxis.data[i].realValue = this.tableY[i].realValue
                    const yAxis = this.options.chartOption.yAxis
                    if (
                      !yAxis.hasOwnProperty("dataValueLengthControl") ||
                      !yAxis.dataValueLengthControl ||
                      !this.options.chartOption.pluginName.find(it => it === "axisLenControlPlugin")
                    ) {
                      temp.xAxis.data[i].value = value
                    }
                  } else {
                    if (typeof this.tableY[i] === "object" && this.tableY[i].hasOwnProperty("value")) {
                      temp.xAxis.data[i].value = this.tableY[i].value
                    } else {
                      temp.xAxis.data[i].value = this.tableY[i]
                    }
                  }
                } else {
                  temp.xAxis.data[i].value = this.tableY[i]
                }
                // temp.xAxis.data[i].value = this.tableY[i]
              }
            }
          } else if (temp.yAxis.type === "category") {
            if (this.tableY.length > temp.yAxis.data.length) {
              const tempLength = this.tableY.length - temp.yAxis.data.length
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.yAxis.data[0] ? temp.yAxis.data[0] : { value: value })),
                  temp.yAxis.data.length + i
                )
                temp.yAxis.data.push(newData)
              }
            } else if (this.tableY.length < temp.yAxis.data.length) {
              temp.yAxis.data.splice(this.tableY.length, temp.yAxis.data.length - this.tableY.length)
            }
            for (let i = 0; i < temp.yAxis.data.length; i++) {
              // 排除空数据
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.yAxis.data.splice(temp.yAxis.data.length, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                if (typeof temp.yAxis.data[i] === "object") {
                  if (temp.yAxis.data[i].realValue) {
                    temp.yAxis.data[i].realValue = this.tableY[i].realValue
                    const yAxis = this.options.chartOption.yAxis
                    if (
                      !yAxis.hasOwnProperty("dataValueLengthControl") ||
                      !yAxis.dataValueLengthControl ||
                      !this.options.chartOption.pluginName.find(it => it === "axisLenControlPlugin")
                    ) {
                      temp.yAxis.data[i].value = value
                    }
                  } else {
                    if (typeof this.tableY[i] === "object" && this.tableY[i].hasOwnProperty("value")) {
                      temp.yAxis.data[i].value = this.tableY[i].value
                    } else {
                      temp.yAxis.data[i].value = this.tableY[i]
                    }
                  }
                } else {
                  temp.yAxis.data[i].value = this.tableY[i]
                }
              }
            }
          }
        } else if (temp.radiusAxis) {
          if (temp.radiusAxis.type === "category") {
            if (this.tableY.length > temp.radiusAxis.data.length) {
              const tempLength = this.tableY.length - temp.radiusAxis.data.length
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.radiusAxis.data[0])),
                  temp.radiusAxis.data.length + i
                )
                temp.radiusAxis.data.push(newData)
              }
            } else if (this.tableY.length < temp.radiusAxis.data.length) {
              temp.radiusAxis.data.splice(this.tableY.length, temp.radiusAxis.data.length - this.tableY.length)
            }
            for (let i = 0; i < temp.radiusAxis.data.length; i++) {
              // 排除空数据
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.radiusAxis.data.splice(temp.radiusAxis.data.length, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                if (typeof temp.radiusAxis.data[i] === "object") {
                  temp.radiusAxis.data[i].value = this.tableY[i].value
                } else {
                  temp.radiusAxis.data[i].value = this.tableY[i]
                }
              }
            }
          }
        } else {
          if (temp.series[0].type == "radar") {
            // 没有坐标轴的图表
            if (this.tableY.length > temp.radar.indicator.length) {
              const tempLength = this.tableY.length - temp.radar.indicator.length
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.radar.indicator[0])),
                  temp.radar.indicator.length + i
                )
                temp.radar.indicator.push(newData)
              }
            } else if (this.tableY.length < temp.radar.indicator.length) {
              temp.radar.indicator.splice(this.tableY.length, temp.radar.indicator.length - this.tableY.length)
            }
            for (let i = 0; i < temp.radar.indicator.length; i++) {
              temp.radar.indicator[i].name = this.tableY[i]
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.radar.indicator.splice(temp.radar.indicator.length, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                temp.radar.indicator[i].name = this.tableY[i]
              }
            }
          } else if (temp.series[0].type == "surface") {
            // 3d 饼图
            if (this.tableY.length > temp.series.length - 1) {
              const tempLength = this.tableY.length - temp.series.length + 1
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.series[0])),
                  temp.series.length - 1 + i
                )
                if (
                  Array.isArray(temp.series[temp.series.length - 1].color) &&
                  temp.series[temp.series.length - 1].color.length > 0
                ) {
                  temp.series[temp.series.length - 1].color.splice(
                    temp.series.length - 1,
                    0,
                    this.defaultColor[(temp.series.length - 1) % this.defaultColor.length]
                  )
                }
                temp.series.splice(temp.series.length - 1, 0, newData)
                temp.series[temp.series.length - 1].data.push({
                  name: "",
                  value: 0
                })
              }
            } else if (this.tableY.length < temp.series.length - 1) {
              //删除数据
              const delPos = temp.series.length - 1 - this.tableY.length
              if (
                Array.isArray(temp.series[temp.series.length - 1].color) &&
                temp.series[temp.series.length - 1].color.length > 0
              ) {
                temp.series[temp.series.length - 1].color.splice(this.tableY.length, delPos)
              }
              temp.series[temp.series.length - 1].data.splice(this.tableY.length, delPos)
              // temp.series.splice(this.tableY.length, delPos)
            }
            for (let i = 0; i < temp.series.length - 1; i++) {
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.series[temp.series.length - 1].data.splice(i, 1)
                temp.series.splice(i, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                temp.series[temp.series.length - 1].data[i].name = this.tableY[i]
                temp.series[i].name = this.tableY[i]
              }
            }
          } else {
            // 没有坐标轴的图表
            let oldTempDataLength = temp.series[this.index].data.length
            //半圆扇形饼图的情况   见大屏饼图样式5
            if (temp.series[0].type === "pie" && temp.series.length > 1 && temp.series[1].type === "gauge") {
              oldTempDataLength = oldTempDataLength / 2
            }
            let dataType = 1
            if (this.tableY.length > oldTempDataLength) {
              const tempLength = this.tableY.length - oldTempDataLength
              for (let i = 0; i < tempLength; i++) {
                let newData = this.setDefaultColor(
                  JSON.parse(JSON.stringify(temp.series[this.index].data[0])),
                  oldTempDataLength + i
                )
                //  插入元素
                if (temp.series[this.index].type === "pie") {
                  newData.value = 0
                  newData.name = this.tableY[i + oldTempDataLength]
                  temp.series[this.index].data.splice(i + oldTempDataLength, 0, newData)
                } else {
                  temp.series[this.index].data.splice(i, 0, newData)
                }
                // temp.series[this.index].data.splice(i, 0, newData)
                if (temp.series[0].type === "pie" && temp.series.length > 1 && temp.series[1].type === "gauge") {
                  temp.series[this.index].data.push({
                    name: null,
                    value: 0,
                    // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
                    itemStyle: {
                      color: "rgba(0,0,0,0)"
                    },
                    tooltip: {
                      show: false,
                      formatter: null
                    }
                  })
                }
              }
            } else if (this.tableY.length < oldTempDataLength) {
              temp.series[this.index].data.splice(this.tableY.length, oldTempDataLength - this.tableY.length)
              dataType = 2
            } else {
              //  修改数据=====>  this.tableX.length === oldDataLen
              dataType = 3
            }
            if (temp.series[this.index].type === "pie" && dataType === 1) {
              oldTempDataLength = oldTempDataLength + 1
            }
            for (let i = 0; i < oldTempDataLength; i++) {
              temp.series[this.index].data[i].name = this.tableY[i]
              if (this.tableY[i] === "" || typeof this.tableY[i] == "undefined") {
                temp.series[this.index].data.splice(oldTempDataLength, 1)
                i = i > 1 ? i - 1 : 0
              } else {
                temp.series[this.index].data[i].name = this.tableY[i]
              }
            }
          }
        }
      }
      if (tdIndex === 2) {
        if (value === "" || typeof value === "undefined") {
          this.tableMax.splice(trIndex - 1, 1) //删除数据
        } else {
          if (this.tableMax.length > trIndex - 1) {
            this.tableMax[trIndex - 1] = Number(value) //修改数据
          } else {
            if (trIndex - this.tableMax.length > 0) {
              //新增数据
              this.tableMax[this.tableMax.length] = Number(value)
            }
          }
        }
        // 如果是雷达图
        if (temp.series[0].type == "radar") {
          if (this.tableMax.length > temp.radar.indicator.length) {
            //新增数据
            const tempLength = this.tableMax.length - temp.radar.indicator.length
            for (let i = 0; i < tempLength; i++) {
              let newData = this.setDefaultColor(
                JSON.parse(JSON.stringify(temp.radar.indicator[0])),
                temp.radar.indicator.length + i
              )
              temp.radar.indicator.push(newData)
            }
          } else if (this.tableMax.length < temp.radar.indicator.length) {
            //删除数据
            temp.radar.indicator.splice(this.tableMax.length, temp.radar.indicator.length - this.tableMax.length)
          }
          for (let i = 0; i < temp.radar.indicator.length; i++) {
            if (this.tableMax[i] === "" || typeof this.tableMax[i] == "undefined") {
              this.tableMax.splice(i, 1)
              temp.radar.indicator.splice(temp.radar.indicator.length, 1)
              i = i > 1 ? i - 1 : 0
            } else {
              temp.radar.indicator[i].max = this.tableMax[i]
              // }
            }
          }
        }
      }
      // 如果是刻度图
      if (temp.series[0].type == "gauge") {
        let progress = temp.series[1].data[0].value / this.tableMax[0]
        progress.toFixed(2)
        temp.series[0].max = this.tableMax[0]
        temp.series[1].axisLine.lineStyle.color[0][0] = progress
      }
      // 如果是水球图,需要提前换算成百分比
      if (temp.series[0].type == "liquidFill") {
        let showRealVal = false
        if (temp.pluginName.indexOf("formatterValToNumber") > -1) {
          showRealVal = true
        }
        temp.series[0].data.forEach((data, index) => {
          let max = this.tableMax[index] || 100
          let progress = this.tableX[index] / max
          temp.series[0].data[index].max = max
          temp.series[0].data[index].value = progress
          if (showRealVal) {
            temp.series[0].data[index].realValue = this.tableX[index]
          }
        })
      }
      // 如果是3d饼图，需要重新组装legand
      if (temp.series[0].type == "surface") {
        let legendData = []
        temp.series[temp.series.length - 1].data.forEach(data => {
          legendData.push(data.name)
        })
        temp.legend.data = legendData
      }
      // 如果是半扇形饼图(大屏饼图样式5)  需要将另外一半设置为data为0，颜色为透明来进行填充
      // if (temp.series[0].type === "pie" && temp.series.length>1  && temp.series[1].type === "gauge") {
      //   let dataLen = temp.series[0].data.length
      //   for (let i = 0; i < dataLen; i++) {
      //     temp.series[0].data.push({
      //       name: null,
      //       value: 0,
      //       // 这里保证了异常情况下(数据都为0时)作为占位的数据在视觉上仍为不可见状态。
      //       itemStyle: {
      //         color: "rgba(0,0,0,0)"
      //       },
      //       tooltip: {
      //         show: false,
      //         formatter: null
      //       }
      //     })
      //   }
      // }
      console.log("temp", temp)
      this.$changeOptionsEV(temp, "chartOption", false)
    },
    setDefaultColor(newData, oldDataLength) {
      if (!newData.hasOwnProperty("itemStyle") || JSON.stringify(newData.itemStyle) === "{}") {
        return newData
      }
      if (typeof newData.itemStyle.color === "object") {
        newData.itemStyle.color.colorStops[0].color =
          this.defaultGradientColor[oldDataLength % this.defaultGradientColor.length][0]
        newData.itemStyle.color.colorStops[1].color =
          this.defaultGradientColor[oldDataLength % this.defaultGradientColor.length][1]
      } else {
        newData.itemStyle.color = this.defaultColor[oldDataLength % this.defaultColor.length]
      }
      return newData
    },
    // 表格序号和表格内容一起滚动
    scrollTableHandle: _throttle(function (event) {
      let scrollTop = event.target.scrollTop
      let scrollLeft = event.target.scrollLeft
      this.$refs.scrollLeft.style.top = -scrollTop + "px"
      this.$refs.scrollTop.style.left = -scrollLeft + "px"
    }, 10),
    // 选中整行
    selectRow(index) {
      if (index > 0) {
        this.select_index = index
        this.delete_content = "删除行"
        this.delete_placement = "left"
        this.selectCol_left = 0
        this.selectRow_Col = "selectRow"
        this.selectRow_top = 18 + 27 * index
      }
    },
    // 选中整列
    selectCol(index) {
      this.select_index = index
      this.delete_content = "删除列"
      this.delete_placement = "top"
      this.selectRow_top = 0
      this.selectRow_Col = "selectCol"
      this.selectCol_left = 24 + 85 * index
    },
    // 删除行/列
    deleteArea() {
      if (this.delete_placement === "top") {
        // 删除整列
        // this.getCurrentInputValHandle("", 0, this.select_index)
        // this.getCurrentInputValHandle("", 1, this.select_index)
      } else {
        // 删除整行
        this.getCurrentInputValHandle("", this.select_index, 0)
        this.getCurrentInputValHandle("", this.select_index, 1)
      }
      // 删除后关闭选中行列状态
      this.selectRow_Col = ""
    }
  }
}
</script>

<style scoped>
.title500_16_22 {
  color: inherit;
}
.data-source-type {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.data-source-type/deep/ .el-radio {
  margin-bottom: 16px;
}
.data-source-type/deep/ .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}

.dataTableContainer .outline {
  font-size: 12px;
  position: relative;
  z-index: 0;
  margin-top: 10px;
}
.dataTableContainer .content {
  width: 228px;
  height: calc(232px + 18px);
  overflow: hidden;
  background-color: var(--dialogBgColor);
  position: relative;
}
.dataTableContainer .content .scrollTop {
  height: 18px;
  width: 204px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  background-color: inherit;
  position: absolute;
  z-index: 44;
  left: 24px;
}
.dataTableContainer .content .scrollTop ul {
  left: 0;
  width: calc(262px * 4);
  height: inherit;
  position: relative;
  text-align: center;
  cursor: pointer;
  margin: 0;
}
.dataTableContainer .content .scrollTop ul li {
  display: block;
  box-sizing: content-box;
  height: 18px;
  width: 68px;
  border: 1px solid var(--borderColorNine);
  float: left;
  position: relative;
  margin: 0 -1px 0 0;
}
.dataTableContainer .content .scrollLeft {
  width: 24px;
  height: 232px;
  background-color: inherit;
  overflow: hidden;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  position: absolute;
  z-index: 33;
  top: 18px;
}
.dataTableContainer .content .scrollLeft ul {
  top: 0;
  position: relative;
  width: 100%;
  background-color: var(--dialogBgColor);
  text-align: center;
  letter-spacing: -1px;
  margin: 0;
  cursor: pointer;
}
.dataTableContainer .content .scrollLeft ul li {
  height: 28px;
  line-height: 28px;
  border: 1px solid var(--borderColorNine);
  position: relative;
  margin: 0 -1px -1px 0;
}
.dataTableContainer .content .scrollTable {
  width: 204px;
  max-height: 232px;
  overflow: scroll;
  position: absolute;
  left: 24px;
  top: 18px;
  z-index: 11;
}
.dataTableContainer .content .scrollTable table {
  border-collapse: collapse;
}
.dataTableContainer .content .scrollTable .cell {
  border: 1px solid var(--borderColorNine);
  width: 68px;
  height: 26px;
}
.dataTableContainer .content .scrollTable .cell.select {
  background: var(--cellSelectBgColor);
  border: 1px double var(--selectBorderColor);
}
.dataTableContainer .content .scrollTable .cell.editing {
  border: 1px double var(--elTreeActiveColor);
}
.dataTableContainer .content .scrollTable .cell .value-viewer {
  display: block;
  box-sizing: border-box;
  height: 26px;
  line-height: 26px;
  width: inherit;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
}
.dataTableContainer .content .scrollTable .cell .data-editor {
  display: block;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  width: 84px;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
  background: none;
  outline: none !important;
  border: 0;
  color: var(--text);
}
.dataTableContainer .content .selectArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 22;
  pointer-events: none;
}
.dataTableContainer .content .selectArea .selectRow {
  width: 228px;
  height: 28px;
  border: 1px solid var(--selectBorderColor);
  background: var(--cellSelectBgColor);
  position: absolute;
}
.dataTableContainer .content .selectArea .selectRow .deleteIcon {
  height: inherit;
  width: 14px;
  line-height: 28px;
  right: 0;
  margin-top: -1px;
}
.dataTableContainer .content .selectArea .selectCol {
  width: 68px;
  height: 250px;
  border: 1px solid var(--selectBorderColor);
  background: var(--cellSelectBgColor);
  position: absolute;
}
.dataTableContainer .content .selectArea .selectCol .deleteIcon {
  width: inherit;
  height: 14px;
  line-height: 14px;
  margin-left: -1px;
  bottom: 0;
}
.deleteIcon {
  position: absolute;
  background-color: rgba(255, 78, 78, 0.4);
  border: 1px solid #ff4e4e;
  text-align: center;
  font-size: 14px;
  color: #ff4e4e;
  pointer-events: auto;
  cursor: pointer;
}
.deleteIcon i {
  font-size: 12px;
}
.dataTableContainer .topLeft {
  width: 24px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--dialogBgColor);
  border-left: 1px solid var(--borderColorNine);
  border-top: 1px solid var(--borderColorNine);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 66;
}
</style>
